module.exports = __webpack_public_path__ + "static/media/snaxeriet.246bc042.png";